import CustomElement from '../core/custom.js';
import Emitter from '../core/emitter.js';

export default window.customElements.define('appear-object', class extends CustomElement {
    constructor() {
        super();

        this._initiated = false
        this._init = this.init.bind(this)
    }

    connectedCallback() {
        super.connectedCallback();

        this._props.once = !(this.dataset.once === "false") || true
        this._props.ratio = Number(this.dataset.ratio) || 0.3

        this._intersectionObserver = new IntersectionObserver((entries) => {
            if (entries[0].intersectionRatio > this._props.ratio) {
                this.classList.add('is-appear')
        
                if (this._props.once) {
                    this._intersectionObserver.unobserve(this)
                }
            } else if (!this._props.once) {
                this.classList.remove('is-appear')
            }
        }, { threshold: this._props.ratio })

		// Wait "document:ready" event, for not trigger animation too early
        Emitter.on('document:ready', this._init);
    }

    disconnectedCallback() {
        super.disconnectedCallback();

        this._intersectionObserver.unobserve(this)

        Emitter.off('document:ready', this._init);
    }

    init() {
        if (this._initiated) return

        this._initiated = true
        this._intersectionObserver.observe(this)
    }
});